import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"
import {Ul, TextLink} from "./components"
import TextMatcher from "../TextMatcher"
import {SEARCH_DATA_GA, SEARCH_DATA_GA_RECENT_SEARCH} from "../../config/constants"
import {removeDeptFromSessionStorage} from "../../utils/removeDeptFromSessionStorage"
import {capitaliseEachWord} from "../../utils/capitaliseEachWord"
import {EnrichedSearch} from "../../models/text"
import RecentSearchListItem from "../RecentSearchListItem"

type Item = {item: string; url: string}

export type RecentSearchesProps = {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    items: Item[]
    typedCharacters: string
    text: EnrichedSearch
}

export const RecentSearches = memo(({items, typedCharacters, text, templating}: RecentSearchesProps) => {
    const {noSearchesCompleted} = text
    const textContainsNoValue = !noSearchesCompleted
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return items.length || textContainsNoValue ? (
        <Ul>
            {items.map(({item, url}) => (
                <RecentSearchListItem key={item} handleClick={removeDeptFromSessionStorage}>
                    <TextLink
                        href={url}
                        data-testid={`header-recent-searches-${item}`}
                        data-ga-v1={SEARCH_DATA_GA}
                        data-ga-v2={item}
                        data-ga-v3={SEARCH_DATA_GA_RECENT_SEARCH}
                    >
                        <TextMatcher text={capitaliseEachWord(item)} textToMatch={typedCharacters} />
                    </TextLink>
                </RecentSearchListItem>
            ))}
        </Ul>
    ) : (
        <Suspense>
            <ComponentName noSearchesCompleted={noSearchesCompleted} />
        </Suspense>
    )
})
RecentSearches.displayName = "RecentSearches"

export default connect(RecentSearches)
